import { SendModalShell } from './SendModalShell.js';
import { SendForm } from './SendForm.js';

interface SendOverviewModalProps {
  open: boolean;
  onClose: () => void;
  course: {
    id: string;
    name: string;
    provider_name?: string;
    cricos_code?: string | null;
  };
}

export function SendOverviewModal({ open, onClose, course }: SendOverviewModalProps) {
  return (
    <SendModalShell open={open} onClose={onClose}>
      <SendForm kind="overview" course={course} onClose={onClose} />
    </SendModalShell>
  );
}
